import { Locale, MainThemeVariants } from 'src/types'
import { COLOR_DICTIONARY } from 'src/constants'

import { SelectOptions } from 'src/features/ColorThemeSelect/types'

export function getColorDictionary(
  locale: Locale['setting']['colorTheme'],
): SelectOptions[] {
  const { defaultTheme, blue, green, red, orange, rose, violet, yellow } =
    locale

  return [
    {
      title: defaultTheme,
      value: MainThemeVariants.DEFAULT,
      color: COLOR_DICTIONARY[MainThemeVariants.DEFAULT],
    },
    {
      title: red,
      value: MainThemeVariants.RED,
      color: COLOR_DICTIONARY[MainThemeVariants.RED],
    },
    {
      title: rose,
      value: MainThemeVariants.ROSE,
      color: COLOR_DICTIONARY[MainThemeVariants.ROSE],
    },
    {
      title: orange,
      value: MainThemeVariants.ORANGE,
      color: COLOR_DICTIONARY[MainThemeVariants.ORANGE],
    },
    {
      title: green,
      value: MainThemeVariants.GREEN,
      color: COLOR_DICTIONARY[MainThemeVariants.GREEN],
    },
    {
      title: blue,
      value: MainThemeVariants.BLUE,
      color: COLOR_DICTIONARY[MainThemeVariants.BLUE],
    },
    {
      title: yellow,
      value: MainThemeVariants.YELLOW,
      color: COLOR_DICTIONARY[MainThemeVariants.YELLOW],
    },
    {
      title: violet,
      value: MainThemeVariants.VIOLET,
      color: COLOR_DICTIONARY[MainThemeVariants.VIOLET],
    },
  ]
}
